import { types } from "@vilocnv/allsetra-core";
import { mapObjectToMarker } from "./map-object-to-marker.mapper";
import { ObjectStatusValue, isInactiveObject } from "app/data/helpers";
import { ObjectsMapMarker } from "../interfaces/object-state.interface";

export function mapObjectsToMarkers(
  objects: types.IObject[] | undefined,
  options?: {
    statusLookup?: Record<string, ObjectStatusValue>;
    showInactiveObjects?: boolean;
  }
): ObjectsMapMarker[] {
  if (!objects) return [];

  const showInactiveObjects = options?.showInactiveObjects ?? false;

  return (
    objects
      ?.map((object) => {
        const status =
          object?.status ??
          (object?.uniqueId
            ? options?.statusLookup?.[object.uniqueId]
            : undefined);
        return mapObjectToMarker(object, status);
      })
      ?.filter((marker): marker is ObjectsMapMarker => !!marker)
      ?.filter((marker) => showInactiveObjects || !marker.isInactive) ?? []
  );
}

export function shouldIncludeMarkerForInactivePreference(
  status: ObjectStatusValue,
  showInactiveObjects: boolean
): boolean {
  return showInactiveObjects || !isInactiveObject(status);
}
